import { Injectable } from '@angular/core';
import { PluginService } from '../../../plugins/services/plugin.service';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';
import { ActivationStart, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ToolbarService {

    protected buttons: Array<any> = [];

    public constructor(private pluginService: PluginService, protected router: Router) {
        this.init();

        this.router.events.subscribe((event) => {
            if (event instanceof ActivationStart) {
                this.clear();
            }
        });
    }

    protected init() {
        const data = {
            inputs: {
                items: this.buttons
            }
        };

        this.pluginService.add('breadcrumbs', 'toolbar', ToolbarComponent, 0, data);
    }

    /**
     * Add a button to the end of the buttons list.
     *
     * @param {Button} data
     */
    public add(data: ButtonInterface) {
        const button = new Button(data);

        this.buttons.push(button);

        return button;
    }

    /**
     * Add a button at the beginning of the buttons list.
     *
     * @param {Button} data
     */
    public prepend(data: ButtonInterface) {
        const button = new Button(data);

        this.buttons.unshift(button);

        return button;
    }

    /**
     * Insert a new button before the specified button.
     *
     * @param {string} before
     * @param {string} name
     * @param data
     */
    public before(before: string, data: ButtonInterface) {
        const index = this.buttons.findIndex((item) => {
            return item.name === before;
        });

        const item = new Button(data);

        this.buttons.splice(index, 0, item);
    }

    /**
     * Insert a new button after the specified button.
     *
     * @param {string} after
     * @param {ButtonInterface} data
     * @param data
     */
    public after(after: string, data: ButtonInterface) {
        const index = this.buttons.findIndex((i) => {
            return i.name === after;
        });

        const item = new Button(data);

        this.buttons.splice(index + 1, 0, item);
    }

    // /**
    //  * Add a button at the beginning of the buttons list.
    //  *
    //  * @param name
    //  * @param {Button} data
    //  */
    // public before(name: string, data: ButtonInterface) {
    //     const before = this.buttons.findIndex((button: ButtonInterface) => {
    //         return name === button.name;
    //     });
    //
    //     const button = new Button(data);
    //
    //     this.buttons = this.buttons.splice(before, 0, button);
    //
    //     return button;
    // }

    /**
     * Remove toolbar button with name
     *
     * @param name
     */
    public remove(name: string) {
        const index = this.buttons.findIndex(button => button.name === name);

        if (index >= 0) {
            this.buttons.splice(index, 1);
        }
    }

    public clear() {
        this.buttons.length = 0;
    }

    public all() {
        return this.buttons;
    }

    public get(name): Button | null {
        return this.buttons.find(button => button.name === name);
    }
}

export class Button implements ButtonInterface {

    public name;

    public type = 'button';

    public text: string;

    public icon: string;

    public classes: string;

    public callback: () => any;

    public loader?: () => boolean;

    public disabled?: () => boolean;

    /**
     * For backwards compatibility.
     *
     * @deprecated
     */
    public color?: string;

    constructor(data: ButtonInterface) {
        this.loader = () => {
            return false;
        };

        this.fill(data);
    }

    protected fill(data: any) {
        Object.keys(data).forEach((key) => {
            this[key] = data[key];
        });

        this.color = data.classes;
    }

    public update(data: Object) {
        this.fill(data);
    }

}

export interface ButtonInterface {

    name: string;

    text?: string;

    // Required unless it is a dropdown.
    callback?: () => any;

    icon?: string;

    classes?: string;

    loader?: () => boolean;

    order?: number;

    disabled?: () => boolean;

    // Required if it is a dropdown.
    items?: Array<Child>;

    authorized?: () => any;

}

export interface Child {

    text: string;

    callback: () => any;

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/toolbar/services/toolbar.service.ts